import { ConditionOperatorsEnum, Filter } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'client_name',
    label: 'DYNAMIC_FILTER.CLIENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'environment_name',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'partner_name',
    label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'email',
    label: 'DYNAMIC_FILTER.EMAIL_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'username',
    label: 'DYNAMIC_FILTER.AD_USERNAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'first_name',
    label: 'DYNAMIC_FILTER.FIRST_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'last_name',
    label: 'DYNAMIC_FILTER.LAST_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'active',
    label: 'DYNAMIC_FILTER.STATUS_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'salt_configured',
    label: 'DYNAMIC_FILTER.SALT_CONFIGURED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'mfa_configured',
    label: 'DYNAMIC_FILTER.MFA_CONFIGURED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'is_integration_user',
    label: 'IS_INTEGRATION_USER_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    field: 'user_uuid',
    label: 'DYNAMIC_FILTER.USER_UUID_KEY',
  },
  {
    field: 'partner_uuid',
    label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY',
  },
  {
    field: 'environment_uuid',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_UUID_KEY',
  },
  {
    field: 'company_uuid',
    label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY',
  },
  {
    field: 'client_uuid',
    label: 'DYNAMIC_FILTER.CLIENT_UUID_KEY',
  },
];
